import React, { useState } from "react";
import TERMS_OF_USE from "../docs/terms-of-use.pdf";
import _ from "lodash";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const LegalDocument = () => {
  const [pageCount, setPageCount] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setPageCount(numPages);
  };

  const renderPages = () => {
    return _.times(pageCount, (index) => {
      return (
        <Page
          key={index}
          pageNumber={index + 1}
          width={800}
          loading=""
          error={
            <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
          }
          noData={
            <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
          }
        />
      );
    });
  };

  return (
    <div className="legal-document">
      <div className="document-container">
        <div className="document">
          <Document
            file={TERMS_OF_USE}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<se-loading loading="true" />}
            error={
              <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
            }
            noData={
              <se-icon size="xlarge">connection_cloud_connection_error</se-icon>
            }
          >
            {renderPages()}
          </Document>
        </div>
      </div>
    </div>
  );
};

export default LegalDocument;
